import { composeIO } from 'react-compose-io'
import { tabelaEditavelErroProcessamentoIO } from './TabelaEditavelErroProcessamento.IO'
import { TabelaEditavelErroProcessamentoView } from './TabelaEditavelErroProcessamento.View'

export const TabelaEditavelErroProcessamento = composeIO(TabelaEditavelErroProcessamentoView, tabelaEditavelErroProcessamentoIO)
